import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    movimento: null,
    saved: false,
    refresh: false,
    refreshTestata: false,
    refreshDettaglio: false,
    page: 'testate',
    gotoBase: false,
    chiave: null,
    creaArticolo: false,
    articoloCreato: null,
    creaClifor: false,
    cliforCreato: null
  },
  getters: {
    movimento: state => state.movimento,
    saved: state => state.saved,
    refresh: state => state.refresh,
    refreshTestata: state => state.refreshTestata,
    refreshDettaglio: state => state.refreshDettaglio,
    page: state => state.page,
    gotoBase: state => state.gotoBase,
    chiave: state => state.chiave,
    creaArticolo: state => state.creaArticolo,
    articoloCreato: state => state.articoloCreato,
    creaClifor: state => state.creaClifor,
    cliforCreato: state => state.cliforCreato
  },
  mutations: {
    SET_MOVIMENTO (state, payload) {
      state.movimento = payload
    },
    CLEAR_MOVIMENTO (state) {
      state.movimento = null
    },
    SET_MOVIMENTO_SAVED (state) {
      state.saved = true
    },
    CLEAR_MOVIMENTO_SAVED (state) {
      state.saved = false
    },
    SET_REFRESH (state, value) {
      if (value === 'testata') state.refreshTestata = true
      if (value === 'dettaglio') state.refreshDettaglio = true
      if (!value) {
        if (state.page === 'testata') state.refreshTestata = true
        if (state.page === 'dettaglio') state.refreshDettaglio = true
      }
    },
    CLEAR_REFRESH (state, value) {
      if (value === 'testata') state.refreshTestata = false
      if (value === 'dettaglio') state.refreshDettaglio = false
      if (!value) {
        if (state.page === 'testata') state.refreshTestata = false
        if (state.page === 'dettaglio') state.refreshDettaglio = false
      }
    },
    SET_PAGE (state, value) {
      state.page = value
    },
    SET_GOTO_BASE (state) {
      state.gotoBase = true
    },
    CLEAR_GOTO_BASE (state) {
      state.gotoBase = false
    },
    SET_CHIAVE(state, payload) {
      state.chiave = payload
    },
    SET_CREA_ARTICOLO(state) {
      state.creaArticolo = true
    },
    CLEAR_CREA_ARTICOLO(state) {
      state.creaArticolo = false
    },
    SET_ARTICOLO_CREATO(state, payload) {
      state.articoloCreato = payload
    },
    SET_CREA_CLIFOR(state) {
      state.creaClifor = true
    },
    CLEAR_CREA_CLIFOR(state) {
      state.creaClifor = false
    },
    SET_CLIFOR_CREATO(state, payload) {
      state.cliforCreato = payload
    }    
  },
  actions: {
  }
}
